// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sayhi-head-beans {\r\n  width: 0.72rem;\r\n  height: 0.72rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
